import React from 'react'

import { StyledDivider } from './FormDividerStyled'

const FormDivider = () => <StyledDivider />

export default FormDivider
